import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setSettings } from "../../redux/settingsSlice";
import { getAllSystemSettingNew } from "../../services/systemSettingService";
import { SYSTEMSETTINGS } from "../../data/constants";
import { RootState } from "../../redux/store";
import useApi from "../../hooks/useApi";
import { Setting } from "../../types/Setting";
import { useUser } from "../../context/UserContext";

export const SettingsProvider = ({ children }) => {
  const dispatch = useDispatch();
  const { executeApi } = useApi();
  const { userId } = useUser();
  const settings = useSelector((state: RootState) => state.settings.settings);

  const fetchSettings = async () => {
    const response = await executeApi<string, Setting[]>(
      getAllSystemSettingNew,
      SYSTEMSETTINGS.PORTAL_CATEGORY
    );
    if (response) {
      dispatch(setSettings(response));
    }
  };

  useEffect(() => {
    if (userId && userId > 0 && settings.length === 0) {
      fetchSettings();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, executeApi, settings.length, userId]);

  return children;
};
